import {useStore} from "zustand";

import {useFluxServices} from "injection/hooks";
import {AutoLayoutStoreState} from "modules/auto_layout/services";

/**
 * Hook to access the complete auto-layout store state.
 * Includes current job, iterations, credits, and UI state.
 */
export function useAutoLayoutState() {
    const {autoLayoutStoreService} = useFluxServices();
    const store = autoLayoutStoreService.getStore();
    return useStore(store);
}

/**
 * Hook to access specific parts of the auto-layout store state.
 * Use this to prevent unnecessary re-renders by selecting only needed state.
 *
 * @param selector Function to select specific state slice
 * @returns The selected state
 */
export function useAutoLayoutStateWithSelector<T>(selector: (state: AutoLayoutStoreState) => T): T {
    const {autoLayoutStoreService} = useFluxServices();
    const store = autoLayoutStoreService.getStore();
    return useStore(store, selector);
}
